<template>
  <svg
    data-test="extension-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.162 20"
  >
    <g>
      <path
        fill="currentColor"
        d="M3.298,14.505c-2.382,0.951-3.788,3.035-3.141,4.658c0.647,1.619,3.103,2.164,5.484,1.213
c1.648-0.66,2.828-1.859,3.185-3.074c0.076-0.142,0.118-0.303,0.118-0.475V7.719l8.67-1.606v7.694
c-1.032-0.289-2.338-0.21-3.621,0.3c-2.382,0.951-3.788,3.035-3.142,4.655c0.646,1.622,3.103,2.165,5.484,1.216
c1.648-0.659,2.829-1.861,3.186-3.076c0.075-0.141,0.117-0.303,0.117-0.473V0.634c0-0.35-0.302-0.634-0.652-0.634L7.55,2.118
c-0.352,0-0.637,0.283-0.637,0.635v4.588c0,0.018,0.004,0.035,0.006,0.053v6.812C5.888,13.916,4.583,13.993,3.298,14.505z"
      />
    </g>
  </svg>
</template>
